import { render } from "./DiligansHomePage.vue?vue&type=template&id=84d8a05e&scoped=true"
import script from "./DiligansHomePage.vue?vue&type=script&lang=js"
export * from "./DiligansHomePage.vue?vue&type=script&lang=js"

import "./DiligansHomePage.vue?vue&type=style&index=0&id=84d8a05e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d8a05e"]])

export default __exports__